import React, { useState, useEffect } from "react";
import "./Exposure.css";
import expo1 from "../assets/expo1.png";
import expo2 from "../assets/expo2.png";
import expo3 from "../assets/expo3.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import next from "../assets/icon2.svg";
import prev from "../assets/icon1.svg";

function NextArrow(props) {
  const { onClick } = props;
  return (
    <div className="slick-arrow slick-next" onClick={onClick}>
      <img src={next} alt="Next" className="arrows" />
    </div>
  );
}

function PrevArrow(props) {
  const { onClick } = props;
  return (
    <div className="slick-arrow slick-prev" onClick={onClick}>
      <img src={prev} alt="Previous" className="arrows" />
    </div>
  );
}


export default function Exposure() {
  const cardData = [
    {
      id: 1,
      image: expo1,
      title: "Social Media Integration",
      description:
        "Increase visibility and attract serious buyers through seamless social media reach.",
    },
    {
      id: 2,
      image: expo2,
      title: "Online & Offline Profile for Instant Sharing",
      description:
        "Share full property profiles instantly using Smart QR codes that work both online and offline.",
    },
    {
      id: 3,
      image: expo3,
      title: "One-Tap Contact Saving via NFC Cards",
      description:
        "Make it effortless for buyers to save and connect with your business instantly with our NFC-enabled cards.",
    },
  ];

  const [slidesToShow, setSlidesToShow] = useState(2);
  const [centerMode, setCenterMode] = useState(true);
  const [centerPadding, setCenterPadding] = useState("30px");

  useEffect(() => {
    const updateSettings = () => {
      const width = window.innerWidth;

      if (width >= 992) {
        setSlidesToShow(2);
        setCenterMode(true);
        setCenterPadding("30px");
      } else if (width >= 700) {
        setSlidesToShow(2);
        setCenterMode(true);
        setCenterPadding("30px");
      } else if (width >= 450) {
        setSlidesToShow(1);
        setCenterMode(true);
        setCenterPadding("60px");
      } else {
        setSlidesToShow(1);
        setCenterMode(true);
        setCenterPadding("20px");
      }
    };

    updateSettings();
    window.addEventListener("resize", updateSettings);
    return () => window.removeEventListener("resize", updateSettings);
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    centerMode,
    centerPadding,
  };

  return (
    <div className="exposure wrapper">
      <div className="expo-container">
        <h2>Get Exposure that Guarantees Real Results With</h2>

        <div className="cards">
          {cardData.map((card) => (
            <div className="card" key={card.id}>
              <img src={card.image} alt={card.title} />
              <div className="content">
                <h3>{card.title}</h3>
                <p>{card.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mobilecards">
          <Slider {...settings}>
            {cardData.map((card) => (
              <div className="card" key={card.id}>
                <img src={card.image} alt={card.title} />
                <div className="content">
                  <h3>{card.title}</h3>
                  <p>{card.description}</p>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
}
